import React, { FC } from 'react';
import { SettingsCardsPageSkeleton } from '../settings/settingsSkeleton';

export const LandingPageSkeleton: FC = () => <SettingsCardsPageSkeleton />;
